export default "<div class=\"tree\">\n    <app-tree [item]=\"item\" [params]=\"params\"></app-tree>\n</div>\n"